<div class="popup-content-wrapper">
  <p class="popup-title">¿Quieres imprimir las entradas?</p>
</div>